import { createReducer, on } from "@ngrx/store";
import { EditLearnerState, initialEditLearnerState } from "./edit-learner.state";
import { SetEditLearner, EditLearner, EditLearnerSuccess, EditLearnerError, LoadLearnerDataSuccess } from "./edit-learner.actions";

export const EditLearnerReducers = createReducer(
  initialEditLearnerState,
  on(SetEditLearner, (_): EditLearnerState => {
    return {
      ...initialEditLearnerState,
      loading: true,
    };
  }),
  on(EditLearner, (state): EditLearnerState => {
    return {
      ...state,
      loading: true,
      result: null,
      error: null
    };
  }),
  on(LoadLearnerDataSuccess, (state, action): EditLearnerState => {
    return {
      ...state,
      data: action.data,
      loading: false
    };
  }),
  on(EditLearnerSuccess, (state, action): EditLearnerState => {
    return {
      ...state,
      loading: false,
      result: action.result
    };
  }),
  on(EditLearnerError, (state, action): EditLearnerState => {
    return {
      ...state,
      loading: false,
      error: action.error
    };
  })
);